import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import { useInjection } from 'inversify-react';
import { observer } from 'mobx-react';
import type React from 'react';
import styled from 'styled-components';
import { TYPES } from '@/engine/ioc';
import type { ImageSlicesListController } from './ImageSlicesList.controller';

export const ImageSlicesList: React.FC = observer(() => {
  const controller = useInjection<ImageSlicesListController>(TYPES.ImageSlicesListController);

  return (
    <Container>
      <List component="nav">
        {controller.imageSlices?.map((imageSlice) => {
          return (
            <ListItemButton
              key={imageSlice.descriptor}
              data-testid={imageSlice.descriptor + 'ImageBtn'}
              onClick={(): void => controller.toggleImageSliceVisibility(imageSlice)}
            >
              <ListItemText>
                {imageSlice.label} <span style={{ fontWeight: 'bold' }}>{imageSlice.isVisible ? 'on' : 'off'}</span>
              </ListItemText>
            </ListItemButton>
          );
        })}
      </List>
    </Container>
  );
});

const Container = styled.div``;
